import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Subheader, Paper, CircularProgress } from 'material-ui';
import { filter, isEmpty, get, map } from 'lodash';
import moment from 'moment';

import PanelMessage from 'components/panels/PanelMessage';
import { fetchUnionData } from 'actions/EmployeePensionAndUnion';
import styles from './styles/Cards';
import { renderUnionRow } from './helpers';

const EmployeePayUnion = ({
  fetchUnion,
  unions,
  unionLoading,
  unionError,
  detailId,
}) => {
  useEffect(() => {
    fetchUnion(detailId);
  }, []);

  const valid = filter(unions, u => moment().isBetween(moment(u.Begda), moment(u.Endda)));
  const latest = valid[0];
  const history = filter(valid, p => p.EmployeeDetailUnionID !== get(latest, 'EmployeeDetailUnionID'));

  if (unionLoading) return <Paper style={styles.loading}><CircularProgress /></Paper>;

  if (unionError) {
    return (<PanelMessage
      type="error"
      iconName="error"
      zDepth={1}
      message={unionError.Message || <FormattedMessage id="error" values={{ name: <FormattedMessage id="Union" /> }} />}
    />);
  }

  const renderList = () => (
    <Paper zDepth={1}>
      {renderUnionRow(latest)}
      {map(history, u => renderUnionRow(u))}
    </Paper>
  );

  return (
    <React.Fragment>
      <Subheader style={styles.subheader}><FormattedMessage id="Union" /></Subheader>
      {!isEmpty(latest)
        ? renderList()
        : <PanelMessage
          zDepth={1}
          message={<FormattedMessage id="No.pay.union" />}
          iconName="info"
          type="info"
        />
      }
    </React.Fragment>
  );
};

EmployeePayUnion.propTypes = {
  fetchUnion: PropTypes.func,
  unions: PropTypes.array,
  unionLoading: PropTypes.bool,
  unionError: PropTypes.object,
  detailId: PropTypes.number,
};

const mapStateToProps = ({ EmployeePensionAndUnionReducer }) =>
  ({
    unions: EmployeePensionAndUnionReducer.unions,
    unionLoading: EmployeePensionAndUnionReducer.unionLoading,
    unionError: EmployeePensionAndUnionReducer.unionError,
  });

const mapDispatchToProps = dispatch => ({
  fetchUnion: detailId => dispatch(fetchUnionData(detailId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeePayUnion);



// WEBPACK FOOTER //
// ./src/containers/pay/EmployeePayUnion.js